export default class Entity {
    id!: string;
    universeId!: string;
    name = '';
    description = '';
    type = '';
    isPlayable = false;
    stats: any[] = [];

    constructor(data?: any) {
        if (data) {
            if (typeof data !== "object") data = JSON.parse(data);
            Object.assign(this, data);
        }
    }
}
